<template>
<div class="component profileContainer">
    <header class="modal-card-head">
        <p class="modal-card-title"></p>

        <div class="columns is-mobile is-multiline">
            <div class="column is-12-tablet  is-4-fullhd  profileImage" v-if="ownProfile">
                <div class="" v-if="this.$store.getters.getUser.avatar!=undefined && this.$store.getters.getUser.avatar!='' && (this.imageData==null||this.imageData==undefined||this.imageData=='')">
                    <img :src="this.$storageURL+'/avatars/'+this.$store.getters.getUser.avatar">

                </div>

                <div class="" v-if="this.imageData!=null&&this.imageData!=undefined&&this.imageData!=''">
                    <img :src="this.imageData">

                </div>
                <input v-if="ownProfile" type="file" @change="onFileChanged">
                <button v-if="ownProfile" @click="onUpload">{{$t('enaq_translation_profile_save')}}</button>
            </div>

            <div class="column is-4-fullhd is-12-tablet  profileImage" v-else>
                <img :src="this.$storageURL+'/avatars/'+this.profile.avatar">

            </div>

            <div class="column is-7-fullhd is-12-mobile is-offset-1-fullhd">
                <div class="columns is-mobile is-multiline">

                    <span class="column is-12 content profileName">{{profile.firstname}} {{profile.name}}</span>

                    <div class="column is-12" v-if="!ownProfile">

                        <div v-if="profile.nickname!=undefined&&profile.nickname!=''&&profile.nickname!=null">
                            <span class="column is-12 content profileName">{{$t('enaq_translation_profile_nickname')}}: {{profile.nickname}}</span>
                        </div>

                    </div>

                    <div v-else class="column is-12 columns is-mobile is-multiline">
                        <span class="column is-2 is-large content">{{$t('enaq_translation_profile_nickname')}}: </span><input class="input column is-8 is-offset-2" v-model="profile.nickname" />
                    </div>

                    <div class="column is-12" v-if="profile.score!=undefined&&profile.score!=''&&profile.score!=null">
                        <span class="column is-12 content profileName">{{profile.score}} {{$t('enaq_translation_profile_score')}}</span>
                    </div>

                    <div class="column is-12" v-if="ownProfile">
                        <label class="checkbox">
                            <input type="checkbox" v-model="profile.acceptHighscoreListing">
{{$t('enaq_translation_profile_highscore_acceptance')}}
                        </label>
                    </div>

                    <span class="column is-3-fullhd is-6-mobile is-large content">{{$t('enaq_translation_profile_birthday')}}</span>
                    <span class="column is-3-fullhd is-6-mobile content is-large">{{profile.birthdate}}</span>

                    <span class="column is-3-fullhd is-6-mobile is-large content">{{$t('enaq_translation_profile_resident_since')}}</span>
                    <span class="column is-3-fullhd is-6-mobile content is-large">{{profile.moveinDate}}</span>
                    <div class="column is-12" v-if="ownProfile">

                        <textarea class="textarea" placeholder="" v-model="profile.description"></textarea>
                        <br>
                        <span class="button is-success" @click="saveProfile">{{$t('enaq_translation_profile_save')}}</span>
                    </div>
                    <div v-else class="column is-12">
                        <div>{{profile.description}}</div>
                    </div>

                </div>
                <div>

                </div>
            </div>
        </div>

    </header>

</div>
</template>

<script>
export default {
    name: 'profile',
    props: ["profileID"],
    mounted: function () {
        this.userId = this.$route.params.id;
        this.getProfile();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            userId: 0,
            profile: "",
            ownProfile: "",
            nickName: "",
            selectedFile: null,
            imageData: null
        }
    },
    methods: {
        getProfile() {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            this.$axios.get(this.$backendURL + "/user/" + this.userId, {
                headers: headerData
            }).then(function (result) {
                this.profile = result.data.user;
                this.ownProfile = result.data.ownProfile;
                this.nickName = result.data.nickname
            }.bind(this))
        },
        onFileChanged(event) {
            this.previewImage(event)
            this.selectedFile = event.target.files[0]
        },

        onUpload() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            const formData = new FormData()
            formData.append('avatar', this.selectedFile, this.selectedFile.name)
            let uploadData = {
                avatar: this.selectedFile
            }
            this.$axios.post(this.$backendURL + "/user/edit/avatar", formData, {
                headers: headerData
            }).then(function (response) {
                this.$router.go();
            }.bind(this))

        },
        saveProfile() {
            this.profile.id += ''
            let userdata = {
                user: this.profile
            }
            this.sendInfoMessage({
                'loading': true
            })
            this.callApi('/user/' + this.profile.id + '/edit', 'post', userdata).then(function (response) {
                this.sendInfoMessage({
                    'text': this.$t('enaq_translation_profile_updated')
                })

            }.bind(this));
        },

        previewImage: function (event) {
            var input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.imageData = e.target.result;
                }
                reader.readAsDataURL(input.files[0]);
            }
        }

    },
    computed: {

    },
}
</script>

<style scoped>
.profileContainer {
    width: 90%;
    margin: auto;
    padding-top: 2%
}

.profileName {
    font-size: 2em;
    font-weight: bolder;
}

.profileImage img {
    max-height: 200px;
}
</style>
